angular.module('impactx.message').controller('MessageDetailCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    '$q',
    'ConfirmationService',
    '$redirect',
    'MessageService',
    'ToolbarService',
    'OneTimeDataTransporter',
    MessageDetailCtrl
]);

function MessageDetailCtrl($scope, dataGen, $routeParams, BackService, $mdToast, $q, ConfirmationService, $redirect, MessageService, ToolbarService, OneTimeDataTransporter) {
    var self = this;
    if ($routeParams.recipientuserid > 0) {
        self.preSetRecipient = true;
    }
    self.searchText = '';
    self.searchTextCC = '';
    self.entries = [];
    self.entriesCC = [];
    self.forReply = $scope.forReply;
    self.canSendMessage = MessageService.canSendMessage();
    self.dataFromTransporter = OneTimeDataTransporter.getData();
    dataGen.getData($scope, {id: $routeParams.id}, "/message/view").then(function () {
        MessageService.getInfoOnce();
        if (self.preSetRecipient) {
            $scope.data.recipients.assigned = [{
                id: $routeParams.recipientuserid,
                value: $routeParams.recipientusername
            }];
        }
        if (self.forReply) {
            self.answer();
        }

        if (self.dataFromTransporter && self.dataFromTransporter.subject) {
            $scope.data.subject.value = self.dataFromTransporter.subject;
        }

        if (self.dataFromTransporter && self.dataFromTransporter.recipients && self.dataFromTransporter.recipients.length > 0) {
            $scope.data.recipients.assigned = self.dataFromTransporter.recipients;
            self.preSetRecipient = true;
        }

        if ($routeParams.id <= 0) {
            var parameters = $redirect.getLastParameters();
            if (angular.isDefined(parameters)) {
                angular.forEach(parameters, function (parameter) {
                    if (angular.isDefined(parameter['deepLink'])) {
                        $scope.data.content.value = parameter['deepLink'];
                    }
                });
            }
        }
        defineButtons();
    });

    $scope.retrieveRecipients = function (searchText) {
        return dataGen.getData({}, {input: searchText}, "/message/view/recipients", null, true);
    };

    this.getEntries = function (searchText) {
        return dataGen.getData({}, {input: searchText}, "/message/view/recipients", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    this.save = function () {
        var messageToSave = $scope.data;
        if (self.dataFromTransporter && self.dataFromTransporter.messageRoute) {
            messageToSave.messageRoute = self.dataFromTransporter.messageRoute;
        }
        if (self.dataFromTransporter && self.dataFromTransporter.messageRouteId) {
            messageToSave.messageRouteId = self.dataFromTransporter.messageRouteId;
        }
        var dataObj = {
            message: messageToSave
        };
        return dataGen.postAsForm($scope, dataObj, "/message/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );

            if (self.dataFromTransporter && self.dataFromTransporter.postSentEndpoint && self.dataFromTransporter.postSentEndpointParams) {
                if (self.dataFromTransporter.submitMessage) {
                    self.dataFromTransporter.postSentEndpointParams.message = messageToSave;
                }
                dataGen.postAsForm({}, self.dataFromTransporter.postSentEndpointParams, self.dataFromTransporter.postSentEndpoint);
            }
        });
    };

    this.answer = function () {
        var dataObj = {
            recipient: $scope.data.sender.id,
            content: $scope.data.content.value,
            creationDate: $scope.data.creationDate.dateValue,
            subject: $scope.data.subject.value

        };
        return dataGen.getData($scope, dataObj, "/message/answer").then(function () {
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.delete = function () {
        var dataObj = {
            ids: [$scope.data.id]
        };
        dataGen.postAsForm($scope, dataObj, "/message/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.followMessageLink = function () {
        if ($scope.data.canFollowRoute && $scope.data.impactXRoute) {
            $redirect.redirectTo(null, $scope.data.impactXRoute);
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.send,
                action: self.save,
                type: 'validation',
                condition: canSendMessage,
                params: {
                    form: $scope.dialogData,
                    disableExpression: {valueFunction: noRecipients, error: $scope.trns.selectARecipient}
                }
            },
            {
                label: $scope.trns.answer,
                action: self.answer,
                type: 'validation',
                condition: canReply,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                labelFunction: getFollowMessageLabel,
                action: self.followMessageLink,
                type: 'dialogaction',
                condition: canFollowMessageLink
            }
        ];
        if ($scope.data.downloadLink) {
            buttonDefinition.push({
                label: $scope.data.downloadLink.label,
                linkFunction: self.getDownloadLink,
                type: 'link',
                condition: canDownload})
        }

        ToolbarService.setButtons(buttonDefinition);
    }

    function isNewMessage() {
        return $scope.data.id == 0;
    }

    function canSendMessage() {
        return isNewMessage() && self.canSendMessage;
    }

    function noRecipients() {
        return $scope.data.recipients.assigned.length == 0;
    }

    function canReply() {
        return !isNewMessage() && self.canSendMessage && $scope.data.canReply;
    }

    function canDelete() {
        return !($scope.data.hasOpenToDo || $scope.data.readOnly) && !isNewMessage() && self.canSendMessage;
    }

    function getFollowMessageLabel() {
        return $scope.data.hasOpenToDo ? $scope.trns.edit : $scope.trns.moreInfo;
    }

    function canFollowMessageLink() {
        return $scope.data.canFollowRoute && $scope.data.impactXRoute && self.canSendMessage;
    }

    function canDownload() {
        return $scope.data.downloadLink.value;
    }

    function getDownloadLink() {
        return $scope.data.downloadLink.value;
    }
}